module.exports = __webpack_public_path__ + "static/media/technoBarnner.3ca3f073.jpg";